import { render, staticRenderFns } from "./AttachmentDialog.vue?vue&type=template&id=06f5e6e1"
import script from "./AttachmentDialog.vue?vue&type=script&lang=js"
export * from "./AttachmentDialog.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDialog.vue?vue&type=style&index=0&id=06f5e6e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports